import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { CardHeader, Stack } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { SERVER_URL, USER_TYPE_GUEST } from '../constants';
import { REFRESH_SECONDS } from '../constants';
import ConfirmDialog from './ConfirmDialog';
import { useParams, useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Snackbar from '@mui/material/Snackbar';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { getEstimatedTime } from '../helpers/Helpers';
import { formatDate } from '../helpers/Helpers';
import FixedScheduleDatePicker from './FixedScheduleDatePicker';
import CommonSnackbar from './CommonSnackbar';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import EditClientNotes from './EditClientNotes';
import { dateToShortDayName } from '../helpers/Helpers';
import OpenDateDynamicQueueDatePicker from './OpenDateDynamicQueueDatePicker';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

function AppLinks(props) {

    const routeParams = useParams();

    const [appLink, setAppLink] = useState(null);

    const [error, setError] = useState(false);

    const [message, setMessage] = useState("");

    const [confirmCode, setConfirmCode] = useState({
        confirmation_code: routeParams.confirmCode
    });

    const [appointmentId, setAppointmentId] = useState();

    const [openSendMessageModal, setOpenSendMessageModal] = useState(false);

    const navigate = useNavigate();


    useEffect(() => {
        fetchAppLink();
        // const interval = setInterval(() => {
        //     fetchAppLink();
        // }, 1000 * REFRESH_SECONDS);
        
        // return () => clearInterval(interval);

    }, []);

    const fetchAppLink = () => {
        console.log("fetchAppLink");
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/detail-applink/' + routeParams.confirmCode, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.data)
            {
                if (data.message === "Unauthenticated.")
                {
                    props.logout();
                }
                setAppLink(data.data);
                setConfirmCode({confirmation_code: data.data.confirmation_code});
                setOpen(true);
            } else {
                if (data.status == 1)
                {
                    setMessage(data.message);
                    setError(true);
                    setOpen(true);
                } else{
                    redirectToHome();
                }
            }
            
        })
        .catch(err => {console.error(err)});
    }

    const confirmAppointment = () => {
        // setAppointmentId(1);
        // setOpenSendMessageModal(true);
        // return;
        // console.log("confirmCode", confirmCode);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/confirm-applink', {
            method: 'POST',
            headers: { 
                'Content-Type':'application/json',
                'Accept':'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify(confirmCode)
        })
        .then(response => response.json())
        .then(data => {
            // console.log("new appointment data", data.data[0]);
            setAppointmentId(data.data[0].appointment_id);
        })
        .catch(err => console.error(err))
    }

    const [confirmDiscardOpen, setConfirmDiscardOpen] = useState(false);

    const onDiscardButtonClick = (event) => {
        setConfirmDiscardOpen(true);
    }

    const handleConfirmDiscard = () => {
        if (props.userType == USER_TYPE_GUEST)
        {
            props.logout();
        }
        else {
            redirectToHome();
        }
    }

    const redirectToHome = () => {
        navigate('/', {replace: true});
    }

    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const handleApplinkModalClose = (event, reason) => {
        if (reason === "backdropClick") {
            // Prevent closing when clicking outside
            return;
        }
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }

        setOpen(false);
        redirectToHome();
    };

    const [selectedDate, setSelectedDate] = useState();
    const [selectedTime, setSelectedTime] = useState();
    const [selectedScheduleId, setSelectedScheduleId] = useState();
    const [selectedTimeSlotId, setSelectedTimeSlotId] = useState();

    const [selectedScheduleCode, setSelectedScheduleCode] = useState();

    const [errorTitle, setErrorTitle] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const snackbar = {
        errorTitle,
        errorMessage,
        setErrorTitle,
        setErrorMessage
    }

    const fetchOpenDateAppLink = () => {
        console.log("fetchOpenDateAppLink ", selectedScheduleCode);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/detail-applink/' + selectedScheduleCode, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.data)
            {
                if (data.message === "Unauthenticated.")
                {
                    props.logout();
                }
                setAppLink(data.data);
                setConfirmCode({confirmation_code: data.data.confirmation_code});
                setOpen(true);
            } else {
                if (data.status == 1)
                {
                    setMessage(data.message);
                    setError(true);
                    setOpen(true);
                } else{
                    redirectToHome();
                }
            }
            
        })
        .catch(err => {console.error(err)});
    }

    const confirmOpenDateDynamicQueue = () => {
        // console.log("selectedScheduleCode", selectedScheduleCode);
        fetchOpenDateAppLink();
    }

    const confirmFixedSched = () => {
        // console.log("confirmCode", routeParams.confirmCode);
        // console.log("selectedTimeSlotId", selectedTimeSlotId);
        setConfirming(true);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/cust/confirm-fixed-schedule', {
            method: 'POST',
            headers: { 
                'Content-Type':'application/json',
                'Accept':'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                "confirmation_code": routeParams.confirmCode,
                "time_slot_id": selectedTimeSlotId
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status == 1) {
                // props.setRecentAppointmentConfirm(true);
                setConfirming(false);
                // console.log(data.data);
                setAppointmentId(data.data.appointment_id);
                // setOpenSendMessageModal(true);
                // redirectToHome();
            } else {
                setErrorTitle("Error");
                setErrorMessage(data.message);
                setConfirming(false);
            }
            
        })
        .catch(err => {
            console.error(err)
        })
    }

    const [confirming, setConfirming] = useState(false);


    if (routeParams)
    {
        if (error)
        {
            return (
                <React.Fragment>
                    <Snackbar anchorOrigin={{ vertical:'top', horizontal:'center' }} open={open} autoHideDuration={60000} onClose={handleClose}>
                        <Alert
                        onClose={handleClose}
                        severity="info"
                        variant="filled"
                        sx={{ width: '100%' }}
                        >
                        { message }
                        </Alert>
                    </Snackbar>
                </React.Fragment>
            );
        }
        else if (appLink)
        {
            // fixed time schedule
            if (appLink.type == 2)
            {
                return(
                    <React.Fragment>
                        <CommonSnackbar snackbar={snackbar} />
                        {appointmentId ? 
                        <EditClientNotes 
                            openSendMessageModal={openSendMessageModal}
                            setOpenSendMessageModal={setOpenSendMessageModal}
                            showButton={false} 
                            notes={""} 
                            officeName={appLink.office_name} 
                            appointmentId={appointmentId} 
                            redirectToHome={redirectToHome}
                            setRecentAppointmentConfirm={props.setRecentAppointmentConfirm}
                        />
                        : null }
                        <BootstrapDialog
                            onClose={handleApplinkModalClose}
                            aria-labelledby="customized-dialog-title"
                            open={true}
                        >
                            <DialogTitle style={{ }} sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                {appLink.office_name}
                            </DialogTitle>
                            <DialogContent sx={{ m: 0, p: 0 }} dividers>
                                <Stack spacing={1}>
                                    <Stack alignItems='center'>
                                        <Stack sx={{ width: '100%' }} spacing={2}>
                                            <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                                                Pick your preferred appointment date and time:
                                            </Typography>
                                            <FixedScheduleDatePicker 
                                                selectedDate={selectedDate}
                                                setSelectedDate={setSelectedDate}
                                                selectedTime={selectedTime}
                                                setSelectedTime={setSelectedTime}
                                                selectedScheduleId={selectedScheduleId}
                                                setSelectedScheduleId={setSelectedScheduleId}
                                                selectedTimeSlotId={selectedTimeSlotId}
                                                setSelectedTimeSlotId={setSelectedTimeSlotId}

                                                schedules={appLink.schedules} 
                                                officeName={appLink.office_name} 
                                            />
                                            { selectedDate && selectedTime && selectedTimeSlotId ?
                                                <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                                                    Confirm date and time by clicking the button below:
                                                </Typography>
                                            : null }
                                            { selectedDate && selectedTime && selectedTimeSlotId ?
                                            <Button 
                                            style={{
                                                
                                            }}
                                            disabled={confirming}
                                            variant="outlined" 
                                            onClick={confirmFixedSched} 
                                            data-id={appLink.confirmCode} 
                                            size="medium">
                                                <CheckCircleOutlineIcon /> Confirm Appointment
                                            </Button>
                                            : null }
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </DialogContent>
                            <DialogActions sx={{ justifyContent: "flex-start" }}>
                                <Button size="small" onClick={onDiscardButtonClick}>Discard</Button>
                            </DialogActions>
                        </BootstrapDialog>
                        <ConfirmDialog
                            title="Discard Appointment?"
                            open={confirmDiscardOpen}
                            setOpen={setConfirmDiscardOpen}
                            onConfirm={handleConfirmDiscard}
                        >
                            Are you sure you want to discard this appointment?
                            { props.userType == USER_TYPE_GUEST ? " Since you are signed-in as GUEST, this cannot be undone and continuing will sign you out of the app immediately." : null  }
                        </ConfirmDialog>
                    </React.Fragment>
                );
            }
            // dynamic queue

            // open date dynamic queue
            if (appLink.type == 1 && appLink.open_date == 1)
            {
                return(
                    <React.Fragment>
                        <CommonSnackbar snackbar={snackbar} />                        
                        <BootstrapDialog
                            onClose={handleApplinkModalClose}
                            aria-labelledby="customized-dialog-title"
                            open={true}
                        >
                            <DialogTitle style={{ }} sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                {appLink.office_name}
                            </DialogTitle>
                            <DialogContent sx={{ m: 0, p: 0 }} dividers>
                                <Stack spacing={1}>
                                    <Stack alignItems='center'>
                                        <Stack sx={{ width: '100%' }} spacing={2}>
                                            <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                                                Pick your preferred appointment date:
                                            </Typography>
                                            <OpenDateDynamicQueueDatePicker 
                                                selectedDate={selectedDate}
                                                setSelectedDate={setSelectedDate}
                                                selectedScheduleCode={selectedScheduleCode}
                                                setSelectedScheduleCode={setSelectedScheduleCode}
                                                schedules={appLink.schedules} 
                                                officeName={appLink.office_name} 
                                            />
                                            { selectedDate ?
                                                <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                                                    Confirm date by clicking the button below:
                                                </Typography>
                                            : null }
                                            { selectedDate ?
                                            <Button 
                                            style={{
                                                
                                            }}
                                            disabled={confirming}
                                            variant="outlined" 
                                            onClick={confirmOpenDateDynamicQueue} 
                                            data-id={appLink.confirmCode} 
                                            size="medium">
                                                <CheckCircleOutlineIcon /> Confirm Date
                                            </Button>
                                            : null }
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </DialogContent>
                            <DialogActions sx={{ justifyContent: "flex-start" }}>
                                <Button size="small" onClick={onDiscardButtonClick}>Discard</Button>
                            </DialogActions>
                        </BootstrapDialog>
                        <ConfirmDialog
                            title="Discard Appointment?"
                            open={confirmDiscardOpen}
                            setOpen={setConfirmDiscardOpen}
                            onConfirm={handleConfirmDiscard}
                        >
                            Are you sure you want to discard this appointment?
                            { props.userType == USER_TYPE_GUEST ? " Since you are signed-in as GUEST, this cannot be undone and continuing will sign you out of the app immediately." : null  }
                        </ConfirmDialog>
                    </React.Fragment>
                );
            }

            // regular dynamic queue
            if (appLink.type == 1 && !appLink.open_date)
            {
                return(
                    <React.Fragment>
                        <CommonSnackbar snackbar={snackbar} />
                        {appointmentId ?
                        <EditClientNotes 
                            openSendMessageModal={openSendMessageModal}
                            setOpenSendMessageModal={setOpenSendMessageModal}
                            showButton={false} 
                            notes={""} 
                            officeName={appLink.office_name} 
                            appointmentId={appointmentId} 
                            redirectToHome={redirectToHome}
                            setRecentAppointmentConfirm={props.setRecentAppointmentConfirm}
                        />
                        : null}
                        <BootstrapDialog
                            onClose={handleApplinkModalClose}
                            aria-labelledby="customized-dialog-title"
                            open={open}
                        >
                            <DialogTitle style={{  }} sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                {appLink.office_name}
                            </DialogTitle>
                            <DialogContent sx={{ m: 0, p: 0 }} dividers>
                                <Stack spacing={1}>
                                    <Stack alignItems='center'>
                                        <Typography variant='h6' color="text.primary" gutterBottom>
                                        {dateToShortDayName(appLink.date)}, {formatDate(appLink.date)}
                                        </Typography>
                                        {formatDate(appLink.date) == 'TODAY' ?
                                            <Typography sx={{ }} color="text.secondary" gutterBottom>
                                            Now serving
                                            </Typography>
                                        : null}
                                        { appLink.paused ? <Chip label={"currently paused"} /> : null }
                                        {formatDate(appLink.date) == 'TODAY' ?
                                            <Typography variant="h3" component="div">
                                            {appLink.now_serving}
                                            </Typography>
                                        : null}
                                        <Typography sx={{ }} color="text.secondary" gutterBottom>
                                        You are
                                        </Typography>
                                        <Typography variant="h3" component="div">
                                        { appLink.last_issued_number + 1 }
                                        </Typography>
                                        <Typography sx={{ }} color="text.secondary" gutterBottom>
                                        On-site time
                                        </Typography>
                                        <Typography variant="h5" component="div">
                                        {getEstimatedTime(appLink.date, appLink.start_time, appLink.average_serve_minutes, appLink.now_serving, appLink.last_issued_number + 1, appLink.num_cancelled)}
                                        </Typography>
                                        <Stack sx={{ width: '100%' }} spacing={2}>
                                            <Alert severity="info">Confirm this appointment by clicking the button below.</Alert>
                                            <Button 
                                            style={{
                                                
                                            }}
                                            disabled={confirming}
                                            variant="outlined" 
                                            onClick={confirmAppointment} 
                                            data-id={appLink.confirmCode} 
                                            size="medium">
                                                <CheckCircleOutlineIcon /> Confirm Appointment
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </DialogContent>
                            <DialogActions sx={{ justifyContent: "flex-start" }}>
                                <Button size="small" onClick={onDiscardButtonClick}>Discard</Button>
                            </DialogActions>
                        </BootstrapDialog>
                        <ConfirmDialog
                            title="Discard Appointment?"
                            open={confirmDiscardOpen}
                            setOpen={setConfirmDiscardOpen}
                            onConfirm={handleConfirmDiscard}
                        >
                            Are you sure you want to discard this appointment?
                            { props.userType == USER_TYPE_GUEST ? " Since you are signed-in as GUEST, this cannot be undone and continuing will sign you out of the app immediately." : null  }
                        </ConfirmDialog>
                    </React.Fragment>
                );
            }
        }
    }
}

export default AppLinks;